// components/LoadingSpinner.jsx
import React from 'react';

const LoadingSpinner = () => {
    return (
        <div className="flex flex-col items-center justify-center py-16">
            <div className="relative">
                <div className="w-12 h-12 rounded-full border-4 border-gray-200"></div>
                <div className="w-12 h-12 rounded-full border-4 border-amber-600 border-t-transparent animate-spin absolute top-0 left-0"></div>
            </div>
            <p className="mt-4 text-gray-500 text-sm">Loading delicious items...</p>
        </div>
    );
};

export default LoadingSpinner;